import React from "react";
import { IoClose } from "react-icons/io5";
import { formatCurrency } from "../../../../utility/formatCurrency";
import { useTranslation } from "react-i18next";

const ViewAgreementDetailsModal = ({ isOpen, onClose, agreement }) => {
    const {t}=useTranslation();
    if (!isOpen || !agreement) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '950px', maxWidth: '95%' }}>
                {/* Modal Header matching established style */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        {t("pageTitles.agreementProcessDetails")}
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
                        <IoClose />
                    </button>
                </div>

                <div className="staff-form-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    
                    {/* Section 1: Tender Information (Read-Only fields from TenderProcess) */}
                    <fieldset className="border p-4 rounded-md mb-6 mx-4">
                        <legend className="text-sm font-bold px-2">{t("forms.agreementProcess.tenderInfo")}:</legend>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 px-2 text-sm">
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px', marginBottom: 0 }}>{t("tables.agreementProcess.tenderId")} :</label>
                                <span className="font-semibold">{agreement.tenderId}</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px', marginBottom: 0 }}>{t("forms.agreementProcess.tenderDate")} :</label>
                                <span className="text-gray-700">{agreement.tenderDate || "N/A"}</span>
                            </div>
                            <div className="flex gap-4 md:col-span-2">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px', marginBottom: 0 }}>{t("forms.agreementProcess.workTitle")} :</label>
                                <span className="text-gray-700">{agreement.workTitle}</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px', marginBottom: 0 }}>{t("forms.agreementProcess.tenderValue")} :</label>
                                <span className="text-gray-800 font-bold">₹ {formatCurrency(agreement.tenderValue)}</span>
                            </div>
                        </div>
                    </fieldset>

                    {/* Section 2: Contractor Details (Read-Only fields from Negotiation) */}
                    <fieldset className="border p-4 rounded-md mb-6 mx-4">
                        <legend className="text-sm font-bold px-2">{t("forms.agreementProcess.contractorInfo")}:</legend>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 px-2 text-sm">
                            <div className="flex gap-4 md:col-span-2">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px', marginBottom: 0 }}>Bidder Name :</label>
                                <span className="text-gray-800">{agreement.bidderName}</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px', marginBottom: 0 }}>Above/Below % :</label>
                                <span className="text-gray-700">{agreement.aboveBelow}%</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px', marginBottom: 0 }}>Bid Amount :</label>
                                <span className="font-bold">₹ {formatCurrency(agreement.bidAmount)}</span>
                            </div>
                        </div>
                    </fieldset>

                    {/* Section 3: Agreement Specifics (Editable fields from Agreement table) */}
                    <fieldset className="border p-4 rounded-md mb-4 mx-4 bg-blue-50/20 border-blue-100">
                        <legend className="text-sm font-bold px-2">{t("forms.agreementProcess.finalAgreementAndBpg")}</legend>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 px-2 text-sm">
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px', marginBottom: 0 }}>{t("forms.agreementProcess.agreementNo")} :</label>
                                <span className="text-gray-900 font-bold">{agreement.agreementNo}</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px', marginBottom: 0 }}>{t("forms.agreementProcess.agreementDate")} :</label>
                                <span className="text-gray-700">{agreement.agreementDate}</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px', marginBottom: 0 }}>{t("forms.agreementProcess.bpg")} :</label>
                                <span className="text-gray-800">{agreement.bpg}</span>
                            </div>
                            <div className="flex gap-4">
                                <label className="staff-modal-label font-bold" style={{ minWidth: '130px', marginBottom: 0 }}>{t("forms.agreementProcess.bpgDate")} :</label>
                                <span className="text-gray-700">{agreement.bpgDate}</span>
                            </div>
                        </div>
                    </fieldset>
                </div>

                <div className="staff-form-footer">
                    <button className="staff-btn-save px-12" onClick={onClose}>
                        {t("common.close")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewAgreementDetailsModal;